"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractStore = void 0;
const contract_store_1 = require("contract-store");
const SemaphoreDemo_json_1 = __importDefault(require("./deployments/goerli/SemaphoreDemo.json"));
const ISemaphore_json_1 = __importDefault(require("./artifacts/@semaphore-protocol/contracts/interfaces/ISemaphore.sol/ISemaphore.json"));
__exportStar(require("./typechain"), exports);
var Network;
(function (Network) {
    Network[Network["goerli"] = 5] = "goerli";
})(Network || (Network = {}));
const SEMAPHORE_GOERLI_ADDRESS = "0x99aAb52e60f40AAC0BFE53e003De847bBDbC9611";
exports.contractStore = new contract_store_1.ContractStore({
    networks: {
        [Network.goerli]: {
            abis: {
                SEMAPHORE_DEMO: SemaphoreDemo_json_1.default.abi,
                SEMAPHORE: ISemaphore_json_1.default.abi
            },
            deployments: {
                SEMAPHORE_DEMO: {
                    address: SemaphoreDemo_json_1.default.address,
                    abiKey: "SEMAPHORE_DEMO"
                },
                SEMAPHORE: {
                    address: SEMAPHORE_GOERLI_ADDRESS,
                    abiKey: "SEMAPHORE"
                },
            }
        }
    },
    globalAbis: {}
});
